<h1 mat-dialog-title *ngIf="title">
    {{title | translate}}
</h1>
<div mat-dialog-content>
    <ng-template [cdkPortalOutlet]="componentPortal" (attached)="setInput($event)"></ng-template>
</div>
<div *ngIf="showActions" mat-dialog-actions align="end">
    <button *ngIf="showCancel" mat-button (click)="closeAfterCancel($event)">{{'CLOSE' | translate}}</button>
</div>